import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ExceptionService, UtilsService } from '../../../xform-compat';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {CompanyReference} from '../../../shared/models/company/company-reference.model';
import {TextContentTypes} from '../../../shared/enums/text-content-types.enum';


/**
 * Data service for company spaces
 */
@Injectable({
  providedIn: 'root'
})
export class CompanyReferencesService {
  private textContentTypes = TextContentTypes;

  constructor(
    private http: HttpClient,
    private exceptionsService: ExceptionService,
    private utilsService: UtilsService
  ) { }

  /**
   * Get all spaces for a single company
   * @param {number} companyId
   * @param params: extra parameters
   * @returns {Observable<any>}: response from the API with the list of spaces
   */
  public getCompanyReferences (companyId: number, params?: any) {
    const url = `/api/rms/referencingnotes/company/${companyId}/references`;
    const httpParams = this.utilsService.generateParams(params);
    return this.http.get(url, {params: httpParams}).pipe(catchError(ex => this.exceptionsService.catchBadResponse(ex)));
  }

  /**
   * Generates a link string for the routerLink based on the company reference
   * @param reference: the company reference to generate the link
   */
  public getEntityLinkFromReference(reference: CompanyReference) {
    switch (reference.textContent.textContentType) {
      case this.textContentTypes.CompanyNote:
        reference.entityLink = ['/company', reference.textContentOwner.parentId];
        reference.queryParams = {
          noteId: reference.id,
          spaceId: reference.ownerId
        };
        break;
      case this.textContentTypes.CompanyThesis:
        reference.entityLink = ['/company', reference.textContentOwner.parentId];
        reference.queryParams = {
          spaceId: reference.ownerId,
          display: 'thesis'
        };
        break;
      case this.textContentTypes.IndicationNote:
        reference.entityLink = ['/indication', reference.ownerId];
        reference.queryParams = {
          noteId: reference.id
        };
        break;
      case this.textContentTypes.InsightNote:
        reference.entityLink = ['/insight', reference.ownerId];
        reference.queryParams = {
          noteId: reference.id
        };
        break;
      case this.textContentTypes.PersonNote:
        reference.entityLink = ['/person', reference.ownerId];
        reference.queryParams = {
          noteId: reference.id
        };
        break;
    }
  }
}
